module.exports = __webpack_public_path__ + "static/pinkunicornmain-47905363e67842013a9589cc4cc71cbc.jpeg";